import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import sdlogo from "../images/logo_icon.png";
import CompanyEditProfile from "./CompanyEditProfile";

const Sidebar = () => {
  const [showModal, setShowModal] = useState(false);
  const location = useLocation(); // Hook to get the current location

  

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Function to check if a path is active
  const isActive = (path) => location.pathname === path;

  return (
    <div className="sidebar-wrapper">
      <div className="sd_logo">
        <a href="">
          <img src={sdlogo} alt="Logo" />
        </a>
      </div>
      <nav className="sidebar-menu">
        <ul className="sidebar-links">
          <li className={isActive("/") ? "active" : ""}>
            <Link to="/">
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.5 8.50547C2.5 7.82754 2.5 7.48858 2.57911 7.17107C2.64923 6.88963 2.76481 6.62151 2.92127 6.37728C3.09778 6.10176 3.34421 5.86902 3.83707 5.40354L5.57041 3.7665C6.60141 2.79278 7.11691 2.30592 7.70498 2.12224C8.22266 1.96055 8.77734 1.96055 9.29502 2.12224C9.88309 2.30592 10.3986 2.79278 11.4296 3.76651L13.1629 5.40354C13.6558 5.86902 13.9022 6.10176 14.0787 6.37728C14.2352 6.62151 14.3508 6.88963 14.4209 7.17107C14.5 7.48858 14.5 7.82754 14.5 8.50547V10.8886C14.5 11.6119 14.5 11.9735 14.4205 12.2702C14.2047 13.0755 13.5758 13.7044 12.7706 13.9202C12.4739 13.9997 12.1122 13.9997 11.3889 13.9997C11.1822 13.9997 11.0789 13.9997 10.9941 13.977C10.7641 13.9153 10.5844 13.7356 10.5227 13.5055C10.5 13.4208 10.5 13.3174 10.5 13.1108V11.333C10.5 11.0233 10.5 10.8685 10.4795 10.7389C10.3665 10.0258 9.80721 9.46647 9.09406 9.35352C8.9645 9.333 8.80967 9.333 8.5 9.333C8.19033 9.333 8.0355 9.333 7.90594 9.35352C7.19279 9.46647 6.63347 10.0258 6.52052 10.7389C6.5 10.8685 6.5 11.0233 6.5 11.333V13.1108C6.5 13.3174 6.5 13.4208 6.47728 13.5055C6.41564 13.7356 6.23594 13.9153 6.00588 13.977C5.9211 13.9997 5.81777 13.9997 5.61111 13.9997C4.8878 13.9997 4.52614 13.9997 4.22942 13.9202C3.42421 13.7044 2.79526 13.0755 2.57951 12.2702C2.5 11.9735 2.5 11.6119 2.5 10.8886V8.50547Z"
                  stroke="#667085"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Home</span>
            </Link>
          </li>


         

          <li className={isActive("/jobs") ? "active" : ""}>
            <Link to="/jobs">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M2.01553 7.97382C2.16936 9.48639 3.44684 10.6667 5 10.6667H11C12.5532 10.6667 13.8306 9.48639 13.9845 7.97382M2.01553 7.97382C2 8.32951 2 8.76674 2 9.33333C2 10.5742 2 11.1946 2.16315 11.6967C2.49287 12.7115 3.28848 13.5071 4.30328 13.8369C4.80539 14 5.42581 14 6.66667 14H9.33333C10.5742 14 11.1946 14 11.6967 13.8369C12.7115 13.5071 13.5071 12.7115 13.8369 11.6967C14 11.1946 14 10.5742 14 9.33333C14 8.76674 14 8.3295 13.9845 7.97382M2.01553 7.97382C2.03402 7.55056 2.07449 7.24278 2.16315 6.96994C2.49287 5.95515 3.28848 5.15954 4.30328 4.82981C4.58171 4.73934 4.89652 4.69904 5.33333 4.68109M13.9845 7.97382C13.966 7.55055 13.9255 7.24278 13.8369 6.96994C13.5071 5.95515 12.7115 5.15954 11.6967 4.82981C11.4183 4.73934 11.1035 4.69904 10.6667 4.68109M10.6667 4.68109V4.66667C10.6667 4.04669 10.6667 3.7367 10.5985 3.48236C10.4136 2.79218 9.87449 2.25308 9.1843 2.06815C8.92997 2 8.61998 2 8 2C7.38002 2 7.07003 2 6.8157 2.06815C6.12551 2.25308 5.58642 2.79218 5.40148 3.48236C5.33333 3.7367 5.33333 4.04669 5.33333 4.66667V4.68109M10.6667 4.68109C10.3158 4.66667 9.88611 4.66667 9.33333 4.66667H6.66667C6.1139 4.66667 5.68425 4.66667 5.33333 4.68109M8 10V11.3333" stroke="#667085" stroke-linecap="round" stroke-linejoin="round"/>
             </svg>
              <span>Jobs</span>
            </Link>
          </li>
          <li className={isActive("/evaluation") ? "active" : ""}>
            <Link to="/evaluation">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path d="M8.05104 13H5C2.79086 13 1 14.7909 1 17C1 18.1046 1.89543 19 3 19H11.6836M12 13.6662L14.3412 16.0049C15.4893 13.9972 17.0934 12.3025 19 11M13 5C13 7.20914 11.2091 9 9 9C6.79086 9 5 7.20914 5 5C5 2.79086 6.79086 1 9 1C11.2091 1 13 2.79086 13 5Z" stroke="#667085" stroke-linecap="round" stroke-linejoin="round"/>
               </svg>
              <span>Evaluations</span>
            </Link>
          </li>
          <li className={isActive("/chats") ? "active" : ""}>
            <Link to="/chats">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M5.33333 6.66667H10.6667M5.33333 9.33333H8M14 8C14 11.3137 11.3137 14 8 14C7.71221 14 7.42916 13.9797 7.15219 13.9406C6.34973 13.8271 5.94848 13.7703 5.84286 13.7622C5.67127 13.7489 5.73279 13.7511 5.5607 13.7524C5.45478 13.7532 5.33404 13.7619 5.09287 13.7791L3.65732 13.8816C3.08571 13.9225 2.79988 13.9429 2.58614 13.8415C2.39852 13.7526 2.24742 13.6015 2.15847 13.4139C2.05713 13.2001 2.07755 12.9143 2.11838 12.3427L2.22092 10.9071C2.23815 10.6659 2.24677 10.5452 2.24759 10.4393C2.24893 10.2672 2.25106 10.3287 2.23783 10.1571C2.22968 10.0515 2.17293 9.65028 2.05943 8.84781C2.02026 8.57084 2 8.28779 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" stroke="#667085" stroke-linecap="round" stroke-linejoin="round"/>
               </svg>
              <span>Chat</span>
            </Link>
          </li>
          <li 
           className={showModal ? "active" : ""}
           onClick={handleShowModal}>
            <Link to="#">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M6.93213 2.85278C7.19004 1.71574 8.80996 1.71574 9.06788 2.85278L9.10207 3.00352C9.26919 3.7403 10.1146 4.09048 10.7538 3.68768L10.8845 3.60526C11.8709 2.98363 13.0164 4.12909 12.3947 5.11547L12.3123 5.24624C11.9095 5.88539 12.2597 6.73081 12.9965 6.89793L13.1472 6.93213C14.2843 7.19004 14.2843 8.80996 13.1472 9.06788L12.9965 9.10207C12.2597 9.26919 11.9095 10.1146 12.3123 10.7538L12.3947 10.8845C13.0164 11.8709 11.8709 13.0164 10.8845 12.3947L10.7538 12.3123C10.1146 11.9095 9.26919 12.2597 9.10207 12.9965L9.06788 13.1472C8.80996 14.2843 7.19004 14.2843 6.93213 13.1472L6.89793 12.9965C6.73081 12.2597 5.88539 11.9095 5.24624 12.3123L5.11547 12.3947C4.12909 13.0164 2.98363 11.8709 3.60526 10.8845L3.68768 10.7538C4.09048 10.1146 3.7403 9.26919 3.00352 9.10207L2.85278 9.06788C1.71574 8.80996 1.71574 7.19004 2.85278 6.93213L3.00352 6.89793C3.7403 6.73081 4.09048 5.88539 3.68768 5.24624L3.60526 5.11546C2.98363 4.12909 4.12909 2.98363 5.11546 3.60526L5.24624 3.68768C5.88539 4.09048 6.73081 3.7403 6.89793 3.00352L6.93213 2.85278Z" stroke="#667085" stroke-linecap="round" stroke-linejoin="round"/>
             <path d="M7.32723 8.00001C7.32723 7.63182 7.63183 7.33334 8.00002 7.33334C8.36821 7.33334 8.67281 7.63182 8.67281 8.00001C8.67281 8.3682 8.36821 8.66667 8.00002 8.66667C7.63183 8.66667 7.32723 8.3682 7.32723 8.00001Z" stroke="#667085" stroke-linecap="round" stroke-linejoin="round"/>
             </svg>
              <span>Settings</span>
            </Link>
          </li>
        </ul>
        <CompanyEditProfile show={showModal} handleClose={handleCloseModal} />
      </nav>
    </div>
  );
};

export default Sidebar;
